/* eslint-disable */
const configUrl = {
  // 需要访问的服务器
  baseUrl: '',

  // 产品名称
  productName: '法务云盘'
}

export default configUrl



// WEBPACK FOOTER //
// ./src/apis/config.js